require("./sitio");
require("bootstrap");
require("@fancyapps/fancybox");
$(document).ready(function () {

// Inicializa el plugin de Slick en el contenedor adecuado
    $("#disenamos-proyectos .disenamos-slide").slick({
        autoplay: true,
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    });

// Luego, una vez que las flechas estén disponibles en el DOM, puedes cambiar su visibilidad según sea necesario.
    $('#disenamos-proyectos .next-btn').click(function() {
        $("#disenamos-proyectos .disenamos-slide").slick('slickNext');
    });

// Inicializa el plugin de Slick en el contenedor adecuado
    $("#nosotros-ayudamos .ayudamos-slide").slick({
        autoplay: true,
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    });

// Luego, una vez que las flechas estén disponibles en el DOM, puedes cambiar su visibilidad según sea necesario.
    $('#nosotros-ayudamos .next-btn').click(function() {
        $("#nosotros-ayudamos .ayudamos-slide").slick('slickNext');
    });


    $('[data-fancybox="diseniamos"]').fancybox({
        // Otras opciones de configuración aquí
        loop: true, // Habilita el bucle de la galería
        slideShow: {
            autoStart: true, // Inicia la reproducción automática al abrir la galería
            speed: 2000 // Velocidad de reproducción automática en milisegundos (opcional)
        }
    });

    $('[data-fancybox="ayudamos"]').fancybox({
        // Otras opciones de configuración aquí
        loop: true, // Habilita el bucle de la galería
        slideShow: {
            autoStart: true, // Inicia la reproducción automática al abrir la galería
            speed: 2000 // Velocidad de reproducción automática en milisegundos (opcional)
        }
    });
});
